/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import Paper from '@mui/material/Paper';
import SnackbarComponent from '../../components/snackbar';
import * as common from '../../appRedux/actions/common';
import * as login from '../../appRedux/actions/login';
import { appVersionAction } from '../../appRedux/actions/app_version';
import * as field from '../../appRedux/actions/field';
import Routes, { RoutesLogin } from '../../routes';
import * as menu from '../../constants/menu';
import Backdrop from '../backdrop';
import useStyles from './styles';

function Layouts(props) {
  const history = useHistory();
  const classes = useStyles();

  useEffect(() => {
    getConfig();
  }, []);

  const getConfig = async () => {
    props.loadingBackdropAction(true);
    await props.appVersionAction();
    await props.validateTokenAction();
    props.loadingBackdropAction(false);
  };

  useEffect(() => {
    if (props.redirect !== null) {
      history.push(
        props.redirectId
          ? {
              pathname: props.redirect,
              search: '?id=' + props.redirectId,
            }
          : props.redirect,
      );
    }
  }, [props.redirect]);

  const menuClick = (router) => {
    props.setFields([{ data: [], field: 'list' }]);
    props.redirectAction(router);
  };

  return (
    <React.Fragment>
      {props.loadingBackdrop ? (
        <Backdrop />
      ) : (
        <>
          {props.loginStatus ? (
            <Box sx={{ pb: 7 }}>
              <Routes />
              {props.menu ? (
                <Paper
                  sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
                  elevation={3}
                >
                  <BottomNavigation
                    showLabels
                    className={classes.bottomNavigation}
                    value={props.navigation}
                    onChange={(event, newValue) => {
                      props.navigationAction(newValue);
                    }}
                  >
                    {menu.menuList.map((obj, index) => (
                      <BottomNavigationAction
                        key={index}
                        onClick={() => menuClick(obj.router)}
                        label={obj.label}
                        icon={obj.icon}
                      />
                    ))}
                  </BottomNavigation>
                </Paper>
              ) : (
                ''
              )}
            </Box>
          ) : (
            <RoutesLogin />
          )}
        </>
      )}
      <SnackbarComponent />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    menu: state.common.menu,
    redirect: state.common.redirect,
    navigation: state.common.navigation,
    redirectId: state.common.redirectId,
    loginStatus: state.config.loginStatus,
    loadingBackdrop: state.common.loadingBackdrop,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    appVersionAction: () => dispatch(appVersionAction()),
    setFields: (data) => dispatch(field.setFields(data)),
    redirectAction: (data) => dispatch(common.redirectAction(data)),
    validateTokenAction: () => dispatch(login.validateTokenAction()),
    navigationAction: (data) => dispatch(common.navigationAction(data)),
    loadingBackdropAction: (status) => dispatch(common.loadingBackdropAction(status)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Layouts);
